// source: design/src/pages/HomePage.tsx (ProductsSection)
export default {
  sectionTitle: '产品与服务',
  sectionTitleEn: 'Products & Services',
  sectionDescription: '融合IT、机器人与设计开发能力，为企业提供从系统集成到产品创新的一站式解决方案。',
  services: [
    {
      id: 'services_ifs-solution',
      icon: 'services/icons/database.svg',
      partnerIcon: 'services/icons/ifs_partner.png',
      name: 'IFS 解决方案',
      service: 'IFS Solutions',
      description: '整合企业财务、采购、生产、销售、人力资源等核心业务流程，实现数据统一管理与实时决策支持，提升运营效率。',
      tags: ['ERP', 'EAM', 'FSM', 'AI'],
      actionText: '了解详情',
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'ifs',
    },
    {
      id: 'services_system-integration',
      // source: design/src/pages/HomePage.tsx (icon: Database, export 2026-04-24)
      icon: 'services/icons/system-integration.svg',
      name: 'SI 系统集成',
      service: 'System Integration',
      description: '从系统规划、开发集成到运维支持，连接企业业务与IT系统，打造高效协同的数字化解决方案。',
      tags: ['MES', 'WMS', 'AI'],
      actionText: '了解详情',
      // source: design/src/pages/HomePage.tsx (icon: ArrowRight, export 2026-04-24)
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'si',
    },
    {
      id: 'services_robot-solution',
      // source: design/src/pages/HomePage.tsx (icon: MessageSquare, export 2026-04-24)
      icon: 'services/icons/robot.svg',
      name: '机器人解决方案',
      service: 'Robotics Solutions',
      description: '通过智能机器人技术赋能企业，实现自动化作业、智能巡检与高效运维，提升生产与运营效率。',
      tags: ['四足机器人', '机器人关节'],
      actionText: '了解详情',
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'robot',
    },
    {
      id: 'services_uiux-design',
      // source: design/src/pages/HomePage.tsx (icon: Pencil, export 2026-04-24)
      icon: 'services/icons/pencil.svg',
      name: 'UI/UX 设计 & 开发',
      service: 'UI/UX Design & Development',
      description: '以用户为中心的数字体验设计与软件开发，从战略到交付全程把控。整合不同使用场景，提供契合用户文化与价值观的卓越设计与高品质开发服务。',
      tags: ['移动端开发', 'APP开发', '网页端开发', '小程序开发与运维'],
      actionText: '了解详情',
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'uiux',
    },
  ],
};
